<script lang="ts">
  import DonorDetail from '../../components/charity/donor/detail.svelte';
  
  export let params: { type: string; id: string };
</script>

<DonorDetail donorType={params.type} donorId={params.id} /> 